__webpack_require__.p = "https://stage.e-erp.vitaltools.io/";